<template lang="pug">
  div
    Section1Widget(to="/team")
    div(v-if="employee")
      b-card.text-left
        b-card-img(v-if="employee.image_url" :src="assets_base_url + employee.image_url")
        b-card-text.h4 {{name}} - {{title}}
        b-card-text {{about}}
        b-card-text.h5.text-primary {{tlang('team.contact_header')}}
        //- b-list-group
        //-   b-list-group-item(v-if="email")
        //-     span.text-primary {{tlang('team.email_field_text')}} 
        //-     span {{email}}
        //-   b-list-group-item(v-if="phone_type") 
        //-     span.text-primary {{phone_type}} 
        //-     span {{employee.phone}}
        //-   b-list-group-item(v-if="social_type")
        //-     b-link.text-info(:href="employee.social_url" target="_blank") {{social_type}}

        //- b-card-text(v-if="email") 
        //-   span.text-primary {{tlang('team.email_field_text')}} 
        //-   span {{email}}
        //- b-card-text(v-if="phone_type") 
        //-   span.text-primary {{phone_type}} 
        //-   span {{employee.phone}}
        //- b-card-text(v-if="social_type")
        //-   b-link.text-info(:href="employee.social_url" target="_blank") {{social_type}}
                
        b-card-text
          div(v-if="email") 
            span.text-primary {{tlang('team.email_field_text')}}
            span.float-right {{email}}

          div(v-if="phone_type") 
            span.text-primary {{phone_type}} 
            span.float-right {{employee.phone}}

          div(v-if="social_type && employee.social_url")
            b-link.text-info(:href="employee.social_url" target="_blank") {{social_type}}
        
    div(v-else-if="!employee")
      p.alert-warning Nothing found.
    
</template>
<script>
import Section1Widget from './components/Section1Widget.vue'
import LangMixin from './common/lang/util'
export default {
  name: 'Employee',
  components: {
    Section1Widget
  },
  mixins: [LangMixin],
  created: function(){
    this.initView(this.$route.params.employee_id)
  },

  watch: {
    $route(to) {
      this.initView(to.params.employee_id)
    }
  },

  data: function(){
    return {
      assets_base_url: process.env.VUE_APP_ASSETS_URL,
      employee: null,
    }
  },

  computed:{
    name: function(){ return this.$root.lang === 'zh' ? this.employee.name_zh : this.employee.name_en; },
    title: function(){ return this.$root.lang === 'zh' ? this.employee.title_zh : this.employee.title_en; },
    email: function(){ return this.$root.lang === 'zh' ? this.employee.email_zh : this.employee.email_en; },
    about: function(){ return this.$root.lang === 'zh' ? this.employee.about_zh : this.employee.about_en; },
    social_type: function(){ return this.$root.lang === 'zh' ? this.employee.social_type_zh : this.employee.social_type_en; },
    phone_type: function(){ return this.$root.lang === 'zh' ? this.employee.phone_type_zh : this.employee.phone_type_en; },
  },
  
  methods:{
    initView: function(empid){
      this.employee = this.$root.employees.find(emp => { return emp.id==empid});
    }
  }
  
}
</script>
